import { render, staticRenderFns } from "./WelcomeToolbar.vue?vue&type=template&id=436e7c2e&scoped=true"
import script from "./WelcomeToolbar.vue?vue&type=script&lang=js"
export * from "./WelcomeToolbar.vue?vue&type=script&lang=js"
import style0 from "./WelcomeToolbar.vue?vue&type=style&index=0&id=436e7c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e7c2e",
  null
  
)

export default component.exports